module.exports = __webpack_public_path__ + "static/media/djeeta-icon.b15a6b63.png";